import React from 'react';

const HouseLineIcon = (props: object) => {
  return (
    <svg
      width="50"
      height="60"
      viewBox="0 0 50 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5621 9.53451C16.8843 8.66389 18.1157 8.66389 18.4379 9.53451L19.096 11.3132C19.1973 11.5869 19.4131 11.8027 19.6868 11.904L21.4655 12.5621C22.3361 12.8843 22.3361 14.1157 21.4655 14.4379L19.6868 15.096C19.4131 15.1973 19.1973 15.4131 19.096 15.6868L18.4379 17.4655C18.1157 18.3361 16.8843 18.3361 16.5621 17.4655L15.904 15.6868C15.8027 15.4131 15.5869 15.1973 15.3132 15.096L13.5345 14.4379C12.6639 14.1157 12.6639 12.8843 13.5345 12.5621L15.3132 11.904C15.5869 11.8027 15.8027 11.5869 15.904 11.3132L16.5621 9.53451Z"
        fill="currentColor"
      />
      <path
        d="M3.125 52.1875H46.875"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.6875 52.1875V39.6875H20.3125V52.1875"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.8125 32.7891V52.1855"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.1875 52.1855V32.7891"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.6875 35.9172L23.8945 16.7083C24.0396 16.563 24.212 16.4477 24.4017 16.3691C24.5913 16.2905 24.7947 16.25 25 16.25C25.2053 16.25 25.4087 16.2905 25.5983 16.3691C25.788 16.4477 25.9604 16.563 26.1055 16.7083L45.3125 35.9172"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 14C8 19.5228 12.4772 24 18 24C23.5228 24 28 19.5228 28 14C28 8.47715 23.5228 4 18 4C12.4772 4 8 8.47715 8 14Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9287 21.0703L3.99996 27.9991"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HouseLineIcon;
